import styled, { css } from 'styled-components'
import { FilterPanelHeader, FilterPanelTitle, CloseButton } from '../FilterPanel/styles'

const CategoryPanel = styled.div`
  margin-bottom: 20px;
`
const CategoryHeader = styled(FilterPanelHeader)`
  @media (min-width: ${props => props.theme.screen_lg_min}) {
    display: none;
  }
`
const CategoriesContainer = styled.ul`
  border-top: 1px solid ${props => props.theme.tokens.color.monochrome.light};
  margin: 0;
  padding: 12px 15px;
  width: 100%;

  @media (min-width: ${props => props.theme.screen_lg_min}) {
    padding: 15px 0;
    overflow: hidden;
  }
`

const CategoryItemWrapper = styled.a`
  flex: 0 0 auto;
  position: relative;
  display: flex;
  align-items: left;
  cursor: pointer;
  font-size: ${props => props.theme.tokens.typography.fontSize.root};
  line-height: ${props => props.theme.tokens.fontStack.body1.lineHeight};
  margin-left: 3px;
  padding: 7px 0;
  text-decoration: none;
  width: 100%;

  ${props =>
    props.active &&
    css`
      font-weight: bold;
    `}
  ${props =>
    props.isSubHeading &&
    css`
      flex: 0 0 auto;
      margin: 25px 0 0;
      padding: 0 20px;
      width: 100%;
      color: ${props.theme.tokens.color.monochrome.darker};
    `}
`

const CategoryItem = styled.span`
  color: ${props => props.theme.tokens.color.monochrome.darker};
  width: 100%;
`

const CategoryListHeader = styled.span`
  color: ${props => props.theme.tokens.color.palette.brand3};
`

export {
  CategoryPanel,
  CategoryHeader,
  FilterPanelTitle as CategoryTitle,
  CloseButton,
  CategoriesContainer,
  CategoryItemWrapper,
  CategoryItem,
  CategoryListHeader
}
